import { useRouteParams as useRouteParamsBase } from '../../../_hooks/useRouteParams';

interface RouteParams {
  clientId: string;
  goalId: string;
  workflowEnded: string;
  tab: string;
}

export const useRouteParams = () => {
  return ADV.defaultRoute?.params ?? useRouteParamsBase<RouteParams>();
};
